import * as React from 'react';

import classnames from 'classnames';

import {colors} from '../colors/colors';
import {CircleWarningIcon, ErrorCircleIcon} from '../icon';

import styles from './sidebar-user-avatar.module.css';

export type StatusIndicator = 'warning' | 'error';

type Props = {
    avatarUrl: string;
    initials: string;
    size: number;
    isActive?: boolean;
    className?: string;
    isOnline?: boolean | null | undefined;
    hasBorder?: boolean;
    statusIndicator?: StatusIndicator;
    statusIndicatorTooltip?: string;
};

export function SidebarUserAvatar(props: Props) {
    const style = {
        width: `${props.size}px`,
        height: `${props.size}px`,
        lineHeight: `${props.size}px`,
        fontSize: Math.floor(props.size / 2 - props.size / 15),
        boxShadow: 'none',
        flexShrink: 0,
        borderRadius: `${props.size}px`,
    } as const;

    const styleName = classnames(props.isActive ? styles['container-active'] : styles.container, {
        [styles['has-border']]: props.hasBorder,
    });

    return (
        <div
            style={style}
            data-tip='Your profile'
            data-place='bottom'
            data-delay-show={50}
            className={classnames(props.className, styleName)}
        >
            {props.avatarUrl ? (
                <img style={style} src={`${props.avatarUrl}?width=100&height=100`} />
            ) : undefined}
            <div style={style} className={styles.initials}>
                {props.initials}
            </div>
            {typeof props.isOnline === 'boolean' && (
                <div
                    className={
                        props.isOnline ? styles['online-indicator'] : styles['offline-indicator']
                    }
                />
            )}
            {props.statusIndicator && (
                <div
                    data-tip={props.statusIndicatorTooltip}
                    data-place='bottom'
                    className={styles['status-indicator']}
                >
                    {props.statusIndicator === 'warning' && (
                        <CircleWarningIcon
                            // @ts-expect-error
                            color={colors.yellow}
                            size={Math.round(props.size * 0.3)}
                            wrapWithDiv={false}
                        />
                    )}
                    {props.statusIndicator === 'error' && (
                        <ErrorCircleIcon
                            // @ts-expect-error
                            color={colors.error}
                            size={Math.round(props.size * 0.3)}
                            wrapWithDiv={false}
                        />
                    )}
                </div>
            )}
        </div>
    );
}
